import { useEffect, useState } from 'react';
import { toast } from 'react-hot-toast';
import { useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import { palette } from '../../../assets/theme/theme';
import Form from '../../../form';
import useForm from '../../../form/hooks/useForm';
import { PropConfig } from '../../../types/EntityConfig';
import { useMutation } from "@tanstack/react-query";
import { genericFileUpload, uploadFile } from '../../../services/api.service';


const toastDuration: number = 3000;


export default function CreateEntity({
  entityName, idProp, tableConfigs, postEntity, setCreatingNewEntity
}: any) {


  const form = useForm({ formConfigs: tableConfigs });



  const anexosMutation = useMutation(({ extension, data }: { extension: string, data: FormData }) => uploadFile({ extension, data }), {
    onSuccess: (data: any) => {
      toast.success("Anexos adicionados com sucesso!");
    },
    onError: (error) => {
      console.log("Error on upload!")
    }
  })



  const submitAllData = async () => {
    const entity = await postEntity(form.state);
    const camposAnexosExistentes: PropConfig[] = tableConfigs.filter((c: PropConfig) => c.type === 'anexos');
    if (camposAnexosExistentes.length > 0) {
      for (let c of camposAnexosExistentes) {
        const documentToSave = new FormData();
        form.state[c.id].map((dt: File) => {
          documentToSave.append(c.id, dt);
        })
        if (c?.options?.anexosEndpointBuildFunction) {
          anexosMutation.mutate({ extension: `${c?.options.anexosEndpointBuildFunction(entity?.data?.id)}/upload`, data: documentToSave });
        }
      }
      console.log("ENtity name: ", entityName)

    }
    console.log("Table configs: ", tableConfigs);
    console.log("Submititng form state: ", form.state);
    setCreatingNewEntity(false);
  }


  const submitData = async () => {

    await toast.promise(
      (async () => {
        await submitAllData();
      })()
      ,
      {
        success: (t: any) => (
          <span>
            <span>Entidade <b>{entityName}</b> criada com sucesso!!</span>
          </span>
        ),
        error: ({ response }: any) => (
          <span>
            <span>Erro ao criar entidade <b>{entityName}</b> <p>{response.data.error}</p></span>
          </span>
        ),
        duration: toastDuration
      } as any
    )
  }




  return (<>

    <Box className='mx-12 mt-8'>
      <Form form={form}
        submitData={submitData}
        tableConfigs={tableConfigs}
        editable={true}
        setEditable={setCreatingNewEntity}
        idProp={idProp}
        entityName={entityName}
        isNewEntity={true}
      />
    </Box>
  </>)



}